module.exports = __webpack_public_path__ + "static/media/5.342dca1f.jpg";